var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"role-tree"},[_c('checkbox-tree',{attrs:{"action-accesses-tree":_vm.actionAccessesTree}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_vm._v(" Uprawnienia ")])])
}]

export { render, staticRenderFns }